(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["client-care"]) return;
  try {
    
(function () {
  function init(root) {
    var tabs = (root || document).querySelectorAll('[data-care-tab]');
    if (!tabs.length) return;
    function pick(h, focus) {
      tabs.forEach(function (t) {
        var on = t.dataset.careTab === h;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        var p = document.getElementById('panel-' + t.dataset.careTab);
        if (p) p.hidden = !on;
        if (on && focus) t.focus();
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t.dataset.careTab); history.replaceState(null, '', '#tab-' + t.dataset.careTab); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return; e.preventDefault();
        var n = tabs[(i + d + tabs.length) % tabs.length]; pick(n.dataset.careTab, true);
      });
    });
    var hash = location.hash.replace('#tab-', '');
    if (hash && document.getElementById('panel-' + hash)) pick(hash);
    if (document.querySelector('.care__form .form-error, .care__form .fade-up')) {
      var f = document.querySelector('.care__form').closest('[role=tabpanel]');
      if (f) pick(f.id.replace('panel-', ''));
    }
  }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-ctabs]').forEach(function (wrap) {
      if (wrap.__ct) return; wrap.__ct = true;
      var tabs = wrap.querySelectorAll('[data-ctab]');
      function pick(id, focus) {
        tabs.forEach(function (t) {
          var on = t.dataset.ctab === id;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = document.getElementById('ct-panel-' + t.dataset.ctab);
          if (p) p.hidden = !on;
          if (on && focus) t.focus();
        });
        var panel = document.getElementById('ct-panel-' + id);
        if (panel && panel.getBoundingClientRect().top > window.innerHeight * 0.85) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      tabs.forEach(function (t, i) {
        t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
        t.addEventListener('click', function () { pick(t.dataset.ctab); });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return; e.preventDefault();
          pick(tabs[(i + d + tabs.length) % tabs.length].dataset.ctab, true);
        });
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { var t = e.target.closest('[data-ctab]'); if (t) t.click(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exchange-refund"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var form = (root || document).querySelector('#exchange-form');
    if (!form || form.__xr) return; form.__xr = true;
    var reason = form.querySelector('[data-xr-reason]');
    var notes = form.querySelector('[data-xr-notes]'), notesLabel = form.querySelector('[data-xr-notes-label]');
    var wallet = form.querySelector('[data-xr-wallet]'), method = form.querySelector('[data-xr-method]');
    function update() {
      var req = (form.querySelector('input[name="contact[request]"]:checked') || {}).value === 'Refund' ? 'refund' : 'exchange';
      var r = reason.value;
      form.querySelectorAll('[data-xr-show]').forEach(function (el) {
        var on = el.dataset.xrShow.split(',').some(function (rule) { var p = rule.split(':'); return p[0] === req && (p[1] === '*' || p[1] === r); });
        el.hidden = !on;
        el.querySelectorAll('[data-xr-req]').forEach(function (f) { f.required = on; f.disabled = !on; });
      });
      var showWallet = req === 'refund' && /wallet|InstaPay|Bank/.test(method.value);
      wallet.hidden = !showWallet;
      wallet.querySelector('input').required = showWallet; wallet.querySelector('input').disabled = !showWallet;
      var faulty = r === 'Faulty or damaged';
      notes.required = faulty;
      notesLabel.textContent = faulty ? 'What is wrong with it?' : 'Anything else (optional)';
    }
    form.addEventListener('change', update);
    update();
  }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const init = (root) => {
    const lb = root.querySelector('[data-lb]');
    if (!lb || lb.__bound) return; lb.__bound = true;
    const shots = [...root.querySelectorAll('[data-lb-open]')];
    const track = lb.querySelector('[data-lb-track]'), count = lb.querySelector('[data-lb-count]');
    let last = null;
    const go = (i, smooth) => track.scrollTo({left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto'});
    const cur = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const label = () => { count.textContent = (cur() + 1) + ' / ' + shots.length; };
    const open = (i) => {
      if (!track.children.length) shots.forEach((s) => {
        const d = document.createElement('div'); d.className = 'lb__slide';
        const img = new Image(); img.src = s.dataset.lbSrc; img.alt = (s.querySelector('img') || {}).alt || '';
        img.addEventListener('click', (e) => { e.stopPropagation(); d.classList.toggle('is-zoom'); });
        d.appendChild(img); track.appendChild(d);
      });
      last = document.activeElement; lb.hidden = false; document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => { go(i, false); label(); lb.querySelector('[data-lb-close]').focus(); });
    };
    const close = () => {
      lb.hidden = true; document.documentElement.style.overflow = '';
      track.querySelectorAll('.is-zoom').forEach((z) => z.classList.remove('is-zoom'));
      if (last) last.focus();
    };
    shots.forEach((s) => s.addEventListener('click', () => open(+s.dataset.lbOpen)));
    lb.querySelector('[data-lb-close]').addEventListener('click', close);
    lb.querySelector('[data-lb-prev]').addEventListener('click', () => go(Math.max(0, cur() - 1), true));
    lb.querySelector('[data-lb-next]').addEventListener('click', () => go(Math.min(shots.length - 1, cur() + 1), true));
    track.addEventListener('scroll', label, {passive: true});
    track.addEventListener('click', (e) => { if (e.target === track || e.target.classList.contains('lb__slide')) close(); });
    document.addEventListener('keydown', (e) => {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') go(Math.min(shots.length - 1, cur() + 1), true);
      if (e.key === 'ArrowLeft') go(Math.max(0, cur() - 1), true);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals"] && !Shopify.designMode) return;
  try {
    
(function () {
  function build(root) {
    (root || document).querySelectorAll('[data-family]').forEach(function (fam) {
      var members = fam.querySelectorAll('[data-member]');
      var tpls = fam.querySelectorAll('template[data-swatch]');
      members.forEach(function (m) {
        var box = m.querySelector('[data-swatches]');
        if (!box || box.childElementCount) return;
        tpls.forEach(function (t) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'sw' + (t.dataset.id === m.dataset.member ? ' is-on' : '');
          b.title = t.dataset.label;
          b.setAttribute('aria-label', t.dataset.label);
          b.innerHTML = '<span style="background:' + t.dataset.hex + '"></span>';
          b.addEventListener('click', function () {
            members.forEach(function (x) { x.hidden = x.dataset.member !== t.dataset.id; });
            var next = fam.querySelector('[data-member="' + t.dataset.id + '"] .sw.is-on');
            if (next) next.focus();
          });
          box.appendChild(b);
        });
      });
    });
  }
  build();
  document.addEventListener('shopify:section:load', function (e) { build(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
